import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import './main.scss';
import {QueryClient, QueryClientProvider} from 'react-query';
import {ReactQueryDevtools} from 'react-query/devtools';
import {createTheme, ThemeProvider} from "@mui/material";

const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element missing');
}

const theme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    color: '#000',
                    borderColor: '#000',
                    '&:hover': {
                        color: '#fff !important',
                        backgroundColor: '#000',
                        borderColor: '#fff',
                    }
                },
            },
        },
    }
});

const queryClient = new QueryClient();

const root = createRoot(container);
root.render((
    <StrictMode>
        <ThemeProvider theme={theme}>
            <QueryClientProvider client={queryClient}>
                <App/>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </ThemeProvider>
    </StrictMode>
));
